const LENGTH_FIELDS = [
  ["panelLinkLengthM", "Panel Link Length"],
  ["stringHomerunLengthM", "String Homerun Length"],
];
const SECTION_FIELDS = [
  ["panelCableSectionMm2", "Panel Cable Section"],
  ["homerunCableSectionMm2", "Homerun Cable Section"],
];

const isPositiveNumber = (value) => value !== "" && value != null &&
  Number.isFinite(Number(value)) && Number(value) > 0;

/** Fields the dynamic DC calculation needs for each designed MPPT branch.
 * These are measurements of the actual installation, so never invent defaults.
 */
export function missingDynamicDcWiring(config) {
  if (config?.pvLosses?.dc?.wiringMode !== "dynamic") return [];
  const design = config?.systemDesign || {};
  const dynamic = config?.pvLosses?.dc?.wiringDynamic || {};
  const defaults = dynamic.default || dynamic.defaults || dynamic["*"] || {};
  const missing = [];

  Object.entries(design).forEach(([inverter, mppts]) => {
    if (!Array.isArray(mppts)) return;
    const branch = dynamic[inverter] || {};
    mppts.forEach((_, index) => {
      const mppt = `MPPT${index + 1}`;
      const values = { ...defaults, ...branch, ...(branch[mppt] || {}) };
      const fields = values.autoSize === false
        ? [...LENGTH_FIELDS, ...SECTION_FIELDS] : LENGTH_FIELDS;
      fields.forEach(([field, label]) => {
        if (!isPositiveNumber(values[field])) missing.push({ inverter, mppt, field, label });
      });
    });
  });

  return missing;
}

const FIELD_NAMES = {
  panelLinkLengthM: ["μήκος σύνδεσης πλαισίων", "panel-link length"],
  stringHomerunLengthM: ["μήκος γραμμής έως τον αντιστροφέα", "string homerun length"],
  panelCableSectionMm2: ["διατομή καλωδίου σύνδεσης πλαισίων", "panel cable section"],
  homerunCableSectionMm2: ["διατομή γραμμής έως τον αντιστροφέα", "homerun cable section"],
  lengthM: ["μήκος καλωδίου", "cable length"],
  cableSectionMm2: ["διατομή καλωδίου", "cable section"],
};

/** Replace backend field paths with an instruction the project owner can act on. */
export function explainMissingPvLossValue(message, isGreek) {
  const text = String(message || "");
  if (!/(Missing required numeric value|Expected positive numeric value)/.test(text) ||
      !text.includes("pvLosses.")) return text;
  const field = text.match(/\.(\w+)(?:, got\b|$)/)?.[1];
  const label = FIELD_NAMES[field]?.[isGreek ? 0 : 1] ||
    (isGreek ? "απαιτούμενη τιμή καλωδίωσης" : "required wiring value");
  return isGreek
    ? `Λείπει ή δεν είναι έγκυρη η τιμή: ${label}. Ανοίξτε τις Απώλειες ΦΒ και συμπληρώστε το αντίστοιχο πεδίο της δυναμικής καλωδίωσης, ή επιλέξτε στατική καλωδίωση με ποσοστιαία παραδοχή.`
    : `Missing or invalid value: ${label}. Open PV Losses and complete the corresponding dynamic wiring field, or choose static wiring with a percentage assumption.`;
}
